module.exports = __webpack_public_path__ + "static/img/9_western_eastern_japan.6cf49a44.png";